module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/assets/icons/material/MaterialIcons-Regular.woff
// module id = ../../../../../src/assets/icons/material/MaterialIcons-Regular.woff
// module chunks = styles